module.exports = __webpack_public_path__ + "static/img/img_idea.ce61e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top/img_idea.png
// module id = 366
// module chunks = 2